module.exports = __webpack_public_path__ + "img/zwischenzeiten6.7158a50c.jpg";